export enum DeviceRechargeType {
    DEBIT = 1,
    CREDIT = 2
}